"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateRangePicker = void 0;
var IctCoreJsApp_1 = require("./../Core/IctCoreJsApp");
require("./JQueryExtensions");
require("daterangepicker");
var DateRangePicker = (function () {
    function DateRangePicker(element, options) {
        this.element = element;
        this.options = options;
        this.OnCreate();
    }
    DateRangePicker.prototype.OnCreate = function () {
        var _this = this;
        var dateRangePickerOptions = {
            autoApply: false,
            showDropdowns: true,
            locale: dateRangePickerLocale[_this.getLanguage()],
            buttonClasses: ['btn', 'btn-sm'],
            applyButtonClasses: 'btn-primary',
            cancelButtonClasses: 'btn-primary'
        };
        if (_this.options != null) {
            if (_this.options.autoApply != null) {
                dateRangePickerOptions.autoApply = _this.options.autoApply;
            }
            if (_this.options.showYearMonthDropdown != null) {
                dateRangePickerOptions.showDropdowns = _this.options.showYearMonthDropdown;
            }
            if (_this.options.language != null) {
                dateRangePickerOptions.locale = dateRangePickerLocale[_this.options.language];
            }
            if (_this.options.maxDaysSpan != null) {
                dateRangePickerOptions.maxSpan = {
                    days: _this.options.maxDaysSpan - 1
                };
            }
            if (_this.options.startDate != null) {
                dateRangePickerOptions.startDate = _this.options.startDate;
            }
            if (_this.options.endDate != null) {
                dateRangePickerOptions.endDate = _this.options.endDate;
            }
            if (_this.options.minDate != null) {
                dateRangePickerOptions.minDate = _this.options.minDate;
            }
            if (_this.options.maxDate != null) {
                dateRangePickerOptions.maxDate = _this.options.maxDate;
            }
            if (_this.options.showTimePicker != null) {
                dateRangePickerOptions.timePicker = _this.options.showTimePicker;
                dateRangePickerOptions.timePicker24Hour = true;
            }
        }
        this.element.daterangepicker(dateRangePickerOptions, function (start, end, label) {
            _this.element.trigger("dateRangeChange", [start, end]);
        });
    };
    DateRangePicker.prototype.getLanguage = function () {
        return IctCoreJsApp_1.$app.getLanguageFromDocument();
    };
    return DateRangePicker;
}());
exports.DateRangePicker = DateRangePicker;
var dateRangePickerLocale = {
    en: {
        "format": "DD/MM/YYYY",
        "separator": " - ",
        "applyLabel": "Apply",
        "cancelLabel": "Cancel",
        "fromLabel": "From",
        "toLabel": "To",
        "customRangeLabel": "Custom",
        "weekLabel": "W",
        "daysOfWeek": [
            "Su",
            "Mo",
            "Tu",
            "We",
            "Th",
            "Fr",
            "Sa"
        ],
        "monthNames": [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December"
        ],
        "firstDay": 1
    },
    nl: {
        "format": "DD-MM-YYYY",
        "separator": " - ",
        "applyLabel": "Bevestigen",
        "cancelLabel": "Sluiten",
        "fromLabel": "Van",
        "toLabel": "Tot",
        "customRangeLabel": "Custom",
        "weekLabel": "W",
        "daysOfWeek": [
            "Zo",
            "Ma",
            "Di",
            "Wo",
            "Do",
            "Vr",
            "Za"
        ],
        "monthNames": [
            "Januari",
            "Februari",
            "Maart",
            "April",
            "Mei",
            "Juni",
            "Juli",
            "Augustus",
            "September",
            "Oktober",
            "November",
            "December"
        ],
        "firstDay": 1
    },
    fr: {
        "format": "DD/MM/YYYY",
        "separator": " - ",
        "applyLabel": "Confirmer",
        "cancelLabel": "Fermer",
        "fromLabel": "De",
        "toLabel": "à",
        "customRangeLabel": "Custom",
        "weekLabel": "S",
        "daysOfWeek": [
            "Di",
            "Lu",
            "Ma",
            "Me",
            "Je",
            "Ve",
            "Sa"
        ],
        "monthNames": [
            "Janvier",
            "Février",
            "Mars",
            "Avril",
            "Mai",
            "Juin",
            "Juillet",
            "Août",
            "Septembre",
            "Octobre",
            "Novembre",
            "Décembre"
        ],
        "firstDay": 1
    },
    de: {
        "format": "YYYY-MM-DD",
        "separator": " - ",
        "applyLabel": "Bestätigen",
        "cancelLabel": "Schliessen",
        "fromLabel": "Von",
        "toLabel": "Bis",
        "customRangeLabel": "Custom",
        "weekLabel": "W",
        "daysOfWeek": [
            "So",
            "Mo",
            "Di",
            "Mi",
            "Do",
            "Fi",
            "Sa"
        ],
        "monthNames": [
            "Januar",
            "Februar",
            "März",
            "April",
            "Mai",
            "Juni",
            "Juli",
            "August",
            "September",
            "Oktober",
            "November",
            "Dezember"
        ],
        "firstDay": 1
    },
    it: {
        "format": "DD/MM/YYYY",
        "separator": " - ",
        "applyLabel": "Confermare",
        "cancelLabel": "Annulla",
        "fromLabel": "Di",
        "toLabel": "a",
        "customRangeLabel": "Custom",
        "weekLabel": "S",
        "daysOfWeek": [
            "Do",
            "Lu",
            "Ma",
            "Me",
            "Gi",
            "Ve",
            "Sa"
        ],
        "monthNames": [
            "Gennaio",
            "Febbraio",
            "Marzo",
            "Aprile",
            "Maggio",
            "Giugno",
            "Luglio",
            "Agosto",
            "Settembre",
            "Ottobre",
            "Novembre",
            "Dicembre"
        ],
        "firstDay": 1
    },
    es: {
        "format": "DD/MM/YYYY",
        "separator": " - ",
        "applyLabel": "Confirmar",
        "cancelLabel": "Cancelar",
        "fromLabel": "Del",
        "toLabel": "Al",
        "customRangeLabel": "Custom",
        "weekLabel": "S",
        "daysOfWeek": [
            "Do",
            "Lu",
            "Ma",
            "Mi",
            "Ju",
            "Vi",
            "Sa"
        ],
        "monthNames": [
            "Enero",
            "Febrero",
            "Marzo",
            "Abril",
            "Mayo",
            "Junio",
            "Julio",
            "Agosto",
            "Septiembre",
            "Octubre",
            "Noviembre",
            "Diciembre"
        ],
        "firstDay": 1
    },
    sv: {
        "format": "YYYY-MM-DD",
        "separator": " - ",
        "applyLabel": "Bekräfta",
        "cancelLabel": "Avbryt",
        "fromLabel": "Från",
        "toLabel": "Till",
        "customRangeLabel": "Custom",
        "weekLabel": "V",
        "daysOfWeek": [
            "Sö",
            "Må",
            "Ti",
            "On",
            "To",
            "Fr",
            "Lö"
        ],
        "monthNames": [
            "Januari",
            "Februari",
            "Mars",
            "April",
            "Maj",
            "Juni",
            "Juli",
            "Augusti",
            "September",
            "Oktober",
            "November",
            "December"
        ],
        "firstDay": 1
    },
    zh: {
        "format": "YYYY/MM/DD",
        "separator": " - ",
        "applyLabel": "确认",
        "cancelLabel": "取消",
        "fromLabel": "从",
        "toLabel": "到",
        "customRangeLabel": "Custom",
        "weekLabel": "W",
        "daysOfWeek": [
            "日",
            "一",
            "二",
            "三",
            "四",
            "五",
            "六"
        ],
        "monthNames": [
            "一月",
            "二月",
            "行进",
            "四月",
            "五月",
            "六月",
            "七月",
            "八月",
            "九月",
            "十月",
            "十一月",
            "十二月"
        ],
        "firstDay": 1
    },
    ja: {
        "format": "YYYY/MM/DD",
        "separator": " - ",
        "applyLabel": "アプライ",
        "cancelLabel": "キャンセル",
        "fromLabel": "から",
        "toLabel": "にする",
        "customRangeLabel": "Custom",
        "weekLabel": "W",
        "daysOfWeek": [
            "日曜",
            "月曜",
            "火曜",
            "水曜",
            "木曜",
            "金曜",
            "土曜"
        ],
        "monthNames": [
            "一月",
            "二月",
            "三月",
            "四月",
            "五月",
            "六月",
            "七月",
            "八月",
            "九月",
            "十月",
            "十一月",
            "十二月"
        ],
        "firstDay": 1
    },
};
